import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { MenuService } from '../../../services/menuService';
import './navigation.scss';
import type { NavItem } from '../../../interfaces/NavItem';
import { Link } from 'react-router-dom';


export const Navigation = function({display,setDisplay}:any){   
    
    const { t } = useTranslation();
    const [navItems, setNavItems] = useState<NavItem[]>([]);
    useEffect(()=> {MenuService().getAllItems()
        .then((res)=>{
            setNavItems(res.data.data);
        })
        .catch((error)=>console.error(error));
    },[]);
    
    const navLinks = [
        {label:t("map.label"),path:'map'},
        {label:t('about.label'),path:'about'},
        {label:t('press_review.label'),path:'press-review'},
        {label:t('memories.label'),path:'memories'},    
        {label:t('contact.label'),path:'contact'},
    ]
    return(
        <>
            <div className={`navigation-container ${display?"show":''}`}>
            {(navItems.length===0)?'':
                    <nav>
                        <ul>
                            {navLinks.map((item,index)=>{
                                return <li className='navigation-item' key={index} onClick={()=>setDisplay(false)}><Link to={item.path} >{item.label}</Link></li>
                            })}
                        </ul>
                    </nav>
                }
            </div>
            {display?
                <div className='layer-background'></div>
            :''}
        </>
    )
}
